/*
 * Copyright (c) 2022. Haodong JU
 */

import Vue from 'vue'
import Vuetify, { colors } from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'
import Fragment from 'vue-fragment'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'typeface-roboto'
// theme Main scss
import vuePlugin from '@highlightjs/vue-plugin'

Vue.use(vuePlugin)
Vue.use(Vuetify)
Vue.use(Fragment.Plugin)

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    // dark: mq.matches,
    dark: false,

    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: true,
      minifyTheme: undefined,
      themeCache: undefined,
    },
    themes: {
      light: {
        primary: '#3063e9',
        secondary: '#304156',
        success: colors.green,
        danger: colors.red,
        warning: colors.deepOrange,
        info: colors.indigo,

        dark: '#242939',
        background: '#fafbfc',
      },
      dark: {
        primary: colors.blue,
        secondary: '#304156',
        success: colors.green,
        danger: colors.red,
        warning: colors.deepOrange,
        info: colors.indigo,
      },
    },
  },
})
